import { render, staticRenderFns } from "./RouteListItem_Assignments.vue?vue&type=template&id=5fc8173d&scoped=true&"
import script from "./RouteListItem_Assignments.vue?vue&type=script&lang=js&"
export * from "./RouteListItem_Assignments.vue?vue&type=script&lang=js&"
import style0 from "./RouteListItem_Assignments.vue?vue&type=style&index=0&id=5fc8173d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc8173d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
